import axios from 'axios'

/**
 * 取得 event 每日發生次數
 * @param {String} name - event 名稱
 * @return {Promise} axios promise
 */
export function requestDailyCount({ name }) {
  return axios.post('/api/v1/events/daily_count', {
    name,
  })
}

/**
 * 紀錄 event
 * @param {String} eventName - event 名稱
 * @param {Object} eventProperties - event 屬性
 * @return {Promise} axios promise
 */
export function requestCreateEventTrack({
  eventName,
  eventProperties,
}) {
  return axios.post('/api/v1/events/track', {
    name: eventName,
    properties: eventProperties,
  })
}
